<template>
  <preview-sp class="pega-sp-print-area">
    <photo-clip-preview-detail-sp :photo-clip="photoClip" />
  </preview-sp>
</template>

<script>
import PhotoClipPreviewDetailSp from '@/components/organisms/PhotoClipPreviewDetailSp'
import PreviewSp from '@/components/templates/PreviewSp'
import photoClipPreviewCommon from '@/lib/photoClipPreviewCommon'
export default {
  components: {
    PreviewSp,
    PhotoClipPreviewDetailSp
  },
  // PC・SP共通処理読み込み
  mixins: [photoClipPreviewCommon]
}
</script>
